export default {
    BASE_URL: "https://dacdemartinique.solutia.live",
    MODE: 'production',
};
